/**
 * Shared ordering control for the location lists (regions, areas, districts,
 * assemblies). They read alphabetically by default; this exposes the options for
 * reordering them and turns the chosen option into the `sort_by`/`sort_order`
 * pair the geo endpoints expect.
 */
export const LOCATION_SORT_OPTIONS = [
  { label: "Name (A – Z)", value: "title:asc" },
  { label: "Name (Z – A)", value: "title:desc" },
  { label: "Code (A – Z)", value: "code:asc" },
  { label: "Code (Z – A)", value: "code:desc" },
  { label: "Newest first", value: "created:desc" },
  { label: "Oldest first", value: "created:asc" },
]

export const DEFAULT_LOCATION_SORT = "title:asc";

export default {
  data() {
    return {
      locationSortOptions: LOCATION_SORT_OPTIONS,
      sortFilter: DEFAULT_LOCATION_SORT,
    }
  },
  computed: {
    locationSortQuery() {
      const [sort_by, sort_order] = (this.sortFilter || DEFAULT_LOCATION_SORT).split(":");
      return { sort_by, sort_order }
    },
    isDefaultLocationSort() {
      return (this.sortFilter || DEFAULT_LOCATION_SORT) === DEFAULT_LOCATION_SORT
    },
  },
  methods: {
    restoreLocationSortFromQuery({ sort_by, sort_order } = {}) {
      if (!sort_by) {
        return;
      }

      const candidate = `${sort_by}:${sort_order || "asc"}`;

      // Anything the endpoints would reject falls back to the alphabetical default.
      if (LOCATION_SORT_OPTIONS.some((option) => option.value === candidate)) {
        this.sortFilter = candidate;
      }
    },
    resetLocationSort() {
      this.sortFilter = DEFAULT_LOCATION_SORT;
    },
  },
}
